import { render, staticRenderFns } from "./SectionHeroWin.vue?vue&type=template&id=b5f748d6&scoped=true&"
import script from "./SectionHeroWin.vue?vue&type=script&lang=js&"
export * from "./SectionHeroWin.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeroWin.vue?vue&type=style&index=0&id=b5f748d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f748d6",
  null
  
)

export default component.exports